module.exports = __webpack_public_path__ + "static/6305-woodrose-8-4dce20104a3c21750bfecc145931041d.jpg";